import React from "react";
import pluralize from "pluralize";
import { Inner, Alert, ChangeButton } from "./styles";
import CryptoTool from "../../../utils/CryptoTool";

function AlertMarkup() {
  return <Alert className="alert">!</Alert>;
}

function MessageMarkup({ configPageUrl, handleClickEditQuantity, mode, unlimitedMode, minPurchaseAmount, overallSelected }) {
  const mealsQMarkup = () => {
    let mealsLeft = 0;

    if (unlimitedMode) {
      mealsLeft = minPurchaseAmount - overallSelected;
      return (
        <>
          <AlertMarkup />
          <>
            Please select {mealsLeft} or more {pluralize("meal", mealsLeft, false)} to continue
          </>
        </>
      );
    }
    return (
      <>
        <AlertMarkup />
          <>Please select additional meals to continue</>
      </>
    );
  };
  return (
    <Inner className="inner-bl disabled">
      {mealsQMarkup()}{" "}
      {configPageUrl.length > 0 && !unlimitedMode && (
        <React.Fragment>
          <span>or </span>
          <a href={configPageUrl}>change your quantity</a>
        </React.Fragment>
      )}
      {mode === "account" && (
        <React.Fragment>
          <span>or </span>
          <ChangeButton
            onClick={(e) => {
              handleClickEditQuantity(e);
            }}
          >
            change your quantity
          </ChangeButton>
        </React.Fragment>
      )}
    </Inner>
  );
}

function CongradsMarkup(minPurchaseAmount) {
  if (minPurchaseAmount > 1) {
    return (
      <Inner className="inner-bl active">
        <b>THANK YOU!</b> You may continue adding items or click NEXT to proceed to checkout.
      </Inner>
    );
  } else {
    return null;
  }
}

export function Limitations({
  isLoaded,
  mode,
  handleClickEditQuantity,
  overallSelected,
  overallLimitations,
  soldOuts,
  selectedBreakfasts,
  breakfastsLimitation,
  selectedEntrees,
  entreesLimitation,
  itemsInCart,
  configPageUrl,
}) {
  const unlimitedMode = overallLimitations === 0 ? true : false;
  const minPurchaseAmount = localStorage.getItem('minPurchase');
  const generateCongradsMarkup = () => {
    return mode !== "account" && !soldOuts ? <CongradsMarkup /> : null;
  };

  const isEnough = () => {
    if (
      (selectedBreakfasts > breakfastsLimitation && selectedEntrees >= entreesLimitation) ||
      (selectedEntrees > entreesLimitation && selectedBreakfasts >= breakfastsLimitation && itemsInCart > 0) ||
      (selectedBreakfasts === breakfastsLimitation && selectedEntrees === entreesLimitation && itemsInCart > 0)
    ) {
      return true;
    }

    return false;
  };

  const limitedMarkup = () => {
    if (isEnough()) {
      return generateCongradsMarkup();
    } else if (!soldOuts && (breakfastsLimitation > 0 || entreesLimitation > 0)) {
      return (
        <>
          {minPurchaseAmount > 1 || CryptoTool.isSafari() ? (
            <MessageMarkup
              configPageUrl={configPageUrl}
              handleClickEditQuantity={handleClickEditQuantity}
              mode={mode}
              unlimitedMode={unlimitedMode}
              minPurchaseAmount={minPurchaseAmount}
              overallSelected={overallSelected}
            />
          ) : null}
        </>
      );
    }
    return null;
  };

  const unlimitedMarkup = () => {
    if (overallSelected >= minPurchaseAmount) {
      return <CongradsMarkup />;
    }
    return (
      <>
        {minPurchaseAmount > 1 && (
          <MessageMarkup
            configPageUrl={configPageUrl}
            handleClickEditQuantity={handleClickEditQuantity}
            mode={mode}
            unlimitedMode={unlimitedMode}
            minPurchaseAmount={minPurchaseAmount}
            overallSelected={overallSelected}
          />
        )}
      </>
    );
  };

  if (isLoaded) {
    return (
      <>
        {unlimitedMode && unlimitedMarkup()}
        {!unlimitedMode && limitedMarkup()}
      </>
    );
  }

  return null;
}
